import { DirectoryLocationCountRequest } from "@/app/api/directory/location/count/route";
import { DeepPartialObject } from "@costar-gen/pds-node-client";
import slugify from "slugify";

type InitCriteria = DeepPartialObject<DirectoryLocationCountRequest>;

const getInitialCriteria = (companyKey: string): InitCriteria => {
  return {
    locationCriteria: { location: undefined, company: { companyKey } },
    sort: 21,
    sortDirection: 1,
  };
};

const getDetailUrl = (companyKey: string, companyName: string): string => {
  return `/annuaire/societes/${companyKey}/${slugify(companyName, {
    lower: true,
  })}/sites`;
};

export { getInitialCriteria, getDetailUrl };
